export enum ConfKeys {
  EnterpriseName = 'EnterpriseName',
  PublicLicenseKey = 'PublicLicenseKey',
  LicensedUntil = 'LicensedUntil',
  MaxControllers = 'MaxControllers',
  LicenseKey = 'LicenseKey',

  IsImageRequired = 'IsImageRequired',
  IsRfidCardRequired = 'IsRfidCardRequired',
  IsPlateRestricted = 'IsPlateRestricted',
  SingleAccessDefaultTrue = 'SingleAccessDefaultTrue',
  KeepAuthAfterSingleAccess = 'KeepAuthAfterSingleAccess',
  NotifyUserOfExistingAuthorization = 'NotifyUserOfExistingAuthorization',
  IsResidentialModeEnabled = 'IsResidentialModeEnabled',
  IsBussinesModeEnabled = 'IsBussinesModeEnabled',
  AllowRgDocRegister = 'AllowRgDocRegister',
  AllowPassportDocRegister = 'AllowPassportDocRegister',
  AllowEmailDocRegister = 'AllowEmailDocRegister',
  IsPermitedRegisteVehicle = 'IsPermitedRegisteVehicle',
  IsPermitedRegistePeople = 'IsPermitedRegistePeople',
  EnableMenuChargeRule = 'EnableMenuChargeRule',

  OperatorSeeResidentsAuths = 'OperatorSeeResidentsAuths',
  OperatorSeeEmployeesAuths = 'OperatorSeeEmployeesAuths',
  OperatorCompaniesEnabled = 'OperatorCompaniesEnabled',
  OperatorResidencesEnabled = 'OperatorResidencesEnabled',
  OperatorSeeReports = 'OperatorSeeReports',
  OperatorSeeVehicles = 'OperatorSeeVehicles',
  OperatorSeeUserDocsOnReports = 'OperatorSeeUserDocsOnReports',
  AllowEditingSensitiveData = 'AllowEditingSensitiveData',

  EasyAppVisitorsMenuEnabled = 'EasyAppVisitorsMenuEnabled',
  BlockOtherUsersContentOnAppAccess = 'BlockOtherUsersContentOnAppAccess',
  DisableInvitePictureCapture = 'DisableInvitePictureCapture',
  EnabledParkingManagement = 'EnabledParkingManagement',
  ParkingManagementAccessPoints = 'ParkingManagementAccessPoints',
  ParkingManagementExtraSlotsBlocked = 'ParkingManagementExtraSlotsBlocked',
  EasyAppInviteDefaultValues = 'EasyAppInviteDefaultValues',
  TotemRegistrationSearchType = 'TotemRegistrationSearchType',
  TotemAuthsReleasedFromLobby = 'TotemAuthsReleasedFromLobby',
  CentralInvitesMenuEnabled = 'CentralInvitesMenuEnabled',
  TimeToLogout = 'TimeToLogout',
  EnableQrCodeAccess = "EnableQrCodeAccess",
  EnableBlockade = "EnableBlockade",
  EnableMandatoryFieldVisitorCompany = "EnableMandatoryFieldVisitorCompany",
  EnableCustomRoleSubType = "EnableCustomRoleSubType",
  BlockadePresets = "BlockadePresets",
  DaysForAnAuthToExpire = "DaysForAnAuthToExpire",
  InviteWelcomeVideoLink = 'InviteWelcomeVideoLink',
  WelcomeVideoMustVisualize = 'WelcomeVideoMustVisualize',
  WelcomeVideoMonthsToExpire = 'WelcomeVideoMonthsToExpire',
  EnableLoginByEmail = 'EnableLoginByEmail',
  SelfRegisterCorporateEmailPattern = 'SelfRegisterCorporateEmailPattern',
  EasyAppTermsAndConditionsFile = 'EasyAppTermsAndConditionsFile',
  AlertSpeeding = 'AlertSpeeding',
  EmailsForSpeedNotification = 'EmailsForSpeedNotification',
  LastDaysOfSpeedRecords = 'LastDaysOfSpeedRecords',
  PdfBodyText = 'PdfBodyText',
  CanalCondominioEnabled = 'CanalCondominioEnabled',
  WinkerEnabled = 'WinkerEnabled',

  CloudServiceEnabled = 'CloudServiceEnabled',
  CloudIdentificationName = 'CloudIdentificationName',
  CloudConnectionString = 'CloudConnectionString',

  AntipassbackBlockTime = 'AntipassbackBlockTime',

  EventRetentionPeriod = 'DaysToRetainEventDataOnDb',
  OldDataBaseDir = 'OldDataBaseDir',

  Vast2Enabled = 'Vast2Enabled',
  Vast2UserName = 'Vast2UserName',
  Vast2Password = 'Vast2Password',

  Module_EasyAppEnabled = 'Module_EasyAppEnabled',
  Module_PackageRegistrationEnabled = 'Module_PackageRegistrationEnabled',
  Module_RoomBookingEnabled = 'Module_RoomBookingEnabled',
  Module_EasyAppConciergeEnabled = 'Module_EasyAppConciergeEnabled',

  LicenseUpdatePending = 'LicenseUpdatePending',

  BirthDateRequired = 'BirthDateRequired',

  LicenseModel = 'LicenseModel',

  DashboardApiKeyEnabled = "DashboardApiKeyEnabled",
  DashboardApiKey = "DashboardApiKey",

  ImgLogo = "ImgLogo",

  SelectedLanguage = "SelectedLanguage",

  IsEmploeeIdEnabled = "IsEmploeeIdEnabled",

  LastSpeedingEvent = "LastSpeedingEvent",

  RecentImports = "RecentImports",
  RfidType = "RfidType"
}

export enum ImportType {
  UsersBatch,
  FromCorporateEmail
}
